import Dexie from 'dexie'
import { Employee } from '../../types/Employee/Employee'
import { ForemanDB } from '../../types/IndexedDB/ForemanDB'
import { NewRequest, RequestBacklog } from '../../types/Work/Request'
import { showErrorToast } from '../CommonServices/alertServices'
import dayjs from 'dayjs'
import { getTransactionTables } from '../../utils/MutationSnapshotUtils'

export const getRequestsOfTaskFB = async (db: ForemanDB, taskId: number, taskType: string) => {
	if (taskType === 'workItemTask') {
		const requests = await db.requests
			.filter((r) => r.taskId === taskId && r.reworkId === undefined)
			.toArray()
		return requests
	} else if (taskType === 'reworkTask') {
		const requests = await db.requests.filter((r) => r.reworkId === taskId).toArray()
		return requests
	}
	return []
}
export const getQCsFB = async (db: ForemanDB) => {
	const qcs = await db.qcWorkers.toArray()
	return qcs
}

export const createNewRequestFB = async (db: ForemanDB, request: NewRequest) => {
	db.setNewLogId()
	return await db.transaction(
		'rw',
		getTransactionTables(db, ['requests', 'employee', 'qcWorkers']),
		async () => {
			const tx = Dexie.currentTransaction
			if (!tx) {
				throw new Error('No active transaction found')
			}
			const worker: Employee = await tx.table('employee').get(request.requestedById)
			if (!worker) {
				throw new Error('Worker not found')
			}
			const assignedTo: Employee | undefined = request.assignedToId
				? await tx.table('qcWorkers').get(request.assignedToId)
				: undefined
			if (!assignedTo) {
                showErrorToast({
					message: 'Assigned to worker not found',
				})
				return
			}
            
			const currentPendingRequests = await tx
				.table('requests')
				.filter((r) => r.taskId === request.taskId && r.status === 'Pending')
				.toArray()
			if (currentPendingRequests.length >= 1) {
				showErrorToast({
					message: 'Only one pending request is allowed per task',
				})
				return
			}

			const newRequestId = await db.generateLocalId('requests', tx)
			const newRequest: RequestBacklog = {
				id: newRequestId,
				requestedBy: `${worker.firstName} ${worker.lastName}`,
				requestedAt: dayjs(new Date().toISOString().replace('Z', '')).toDate(),
				assignedTo: assignedTo.firstName + ' ' + assignedTo.lastName,
				assignedToId: assignedTo.id,
				comment: request.comments,
				status: 'Pending',
				hasAttachments: false,
				inspectedQuantity: 0,
				taskId: request.taskId,
				reworkId: request.taskType === 'reworkTask' ? request.taskId : undefined,
			}
			await tx.table('requests').add(newRequest)
			await tx.table('mutations').add({
				route: `/Requests`,
				method: 'POST',
				body: newRequest,
				title: `Created request for ${worker.firstName} ${worker.lastName}`,
				createdAt: new Date(),
				id: db.getLastLogId(),
			})
		},
	)
}
